
































































































































































































































































































































































































































































import { Component, Vue as VueClass, Watch } from 'vue-property-decorator'
import IconSync from '@/app/ui/assets/icon_sync.vue'
import controller from '@/app/ui/controllers/ReschedulePickupController'
import pickupController from '@/app/ui/controllers/PickupController'
import dayjs from 'dayjs'
import dayjsDuration from 'dayjs/plugin/duration'
import { Utils } from '@/app/infrastructures/misc'
import { ReschedulePickup, SubDistrict, Village } from '@/domain/entities/ReschedulePickup'
import { EnumReschedulePickupStatus, EnumReschedulePickupType } from '@/app/infrastructures/misc/Constants/reschedulePickup'
import PopupBox from '../components/PopupBox/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DateTimePickerV2 from '@/app/ui/components/DateTimePickerV2/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import { DataObject, HeaderObject, SortValueObject } from '@/app/ui/components/DataTableV2/type'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import ModalSuccess from '../components/Modals/ModalSuccess.vue'
import ModalConfirmation from '../components/Modals/ModalConfirmation.vue'
import ModalInput from '../components/Modals/ModalInput.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import Badge from '@/app/ui/components/Badge/index.vue'
import AscendingIcon from '@/app/ui/assets/ascending_icon.vue'
import IconWarningCircle from '@/app/ui/assets/icon_warning_circle.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PriorityIcon from '@/app/ui/assets/ics_f_priority-fast.vue'
import Vue from 'vue'
import { FlagsAccount } from '@/feature-flags'

interface Dropdown {
  value: string | number
  label: string
}

dayjs.extend(dayjsDuration)

@Component({
  components: {
    IconSync,
    DateTimePickerV2,
    TextInput,
    DropdownSelect,
    PopupBox,
    DataTableV2,
    IconWhatsApp,
    Button,
    ModalConfirmation,
    ModalInput,
    ModalSuccess,
    PaginationNav,
    Badge,
    AscendingIcon,
    IconWarningCircle,
    EyeIcon,
    EyeDisabledIcon,
    PriorityIcon
  },
})
class RescheduleV2 extends VueClass {
  controller = controller
  pickupController = pickupController
  popupFilterVisible = false
  villageOptions: Array<Dropdown> = []
  subDistrictOptions: Array<Dropdown> = []
  appliedFilter = 0
  isButtonDisable = true
  dataReschedule: DataObject[][] = []
  selectedShipmentId: string[] = []
  showModal = {
    confirm: false,
    success: false,
    connection: false,
    input: false
  }
  modalConfirmation = {
    title: "Terima Jadwal Ulang Pick Up?",
    actionTitle: "Terima",
    description: "Pastikan data yang Anda terima sudah sesuai"
  }
  requestApprove: string[] = []
  modalInputValue = ''
  successModal = {
    title: "Terima Jadwal Ulang Berhasil",
    description: "Jadwal ulang berhasil dibuat"
  }

  rescheduleOptions: Array<Dropdown> = [
    { label: 'Semua', value: '' },
    { label: 'Pergantian Waktu', value: EnumReschedulePickupType.CHANGE_TIME },
    { label: 'Pergantian Waktu Dan Kurir', value: EnumReschedulePickupType.CHANGE_TIME_AND_COURIER },
  ]

  parameters = {
    page: 1,
    perPage: 10,
    search: '',
    date: {
      start: null,
      end: null,
    },
    village: this.villageOptions[-1],
    subDistrict: this.subDistrictOptions[-1],
    schedule: this.rescheduleOptions[0],
    sort: {
      name: '',
      direction: '',
    },
    originCountry: ''
  }

  customDateShortcuts = [
    { key: 'chooseDate', label: 'Tentukan Tanggal', value: 0 },
    { key: 'last7Days', label: '7 Hari Terakhir', value: 7 },
    { key: 'last14Days', label: '14 Hari Terakhir', value: 14 },
    { key: 'last30Days', label: '30 Hari Terakhir', value: 30 },
  ]

  headers = [
    this.headerCellMapper('', '32px'),
    this.headerCellMapper('No.', '60px'),
    this.headerCellMapper('Nama pengirim', '200px', true, 'fullname', '20px'),
    this.headerCellMapper('Total Shipment (koli)', '160px', false, 'total_shipment', '16px'),
    this.headerCellMapper('Tipe Jadwal Ulang', '160px'),
    this.headerCellMapper('Kurir', '170px'),
    this.headerCellMapper('Waktu Jadwal Ulang', '180px', false, 'rescheduled_at', '16px'),
    this.headerCellMapper('Alamat', '200px'),
    this.headerCellMapper('Waktu Pengajuan', '175px', true, 'requested_at', '12px'),
    this.headerCellMapper('Durasi', '180px', true, 'duration', '16px'),
    this.headerCellMapper('Status Pengajuan', '175px'),
    this.headerCellMapper('Aksi', '80px'),
  ]

  crrscdTableSlotNames = [
    'checkbox',
    '',
    'sender',
    'totalkoli',
    'rescheduletype',
    'courier',
    'rescheduletime',
    'address',
    'approvaltime',
    'duration',
    'statusapproval',
    'atur',
  ]

  created(): void {
    this.getSubDistrict()
    this.fetchReschedulePickup(true)
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public waCourierHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menanyakan terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public mapsHref(lat: string, lon: string): string {
    const latLon = `${lat},${lon}`
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      latLon
    )}`
  }


  get pageShippentId(): string[] {
    return (this.controller.dataReschedulePickups ?? [])
      .map(g => g.shipmentId)
      .filter((id): id is string => typeof id === "string");
  }

  public onToggleSelectAll(ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    const pageShipmenttIds = this.pageShippentId
    if (checked) {
      const merged = new Set([...this.selectedShipmentId, ...pageShipmenttIds])
      this.selectedShipmentId = [...merged]
    } else {
      const drop = new Set(pageShipmenttIds)
      this.selectedShipmentId = this.selectedShipmentId.filter(
        h => !drop.has(h)
      )
    }
  }

  public onToggleRowCheckbox(shipmentId: string, ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    if (checked) {
      if (!this.selectedShipmentId.includes(shipmentId)) {
        this.selectedShipmentId = [...this.selectedShipmentId, shipmentId]
      }
    } else {
      this.selectedShipmentId = this.selectedShipmentId.filter(
        h => h !== shipmentId
      )
    }
  }

  public isRowSelected(shipmentId: string): boolean {
    return this.selectedShipmentId.includes(shipmentId)
  }

  get isAllPageSelected(): boolean {
    const ids = this.pageShippentId
    return (
      ids.length > 0 &&
      ids.every(h => this.selectedShipmentId.includes(h))
    )
  }

  get isSomePageSelected(): boolean {
    const ids = this.pageShippentId
    return ids.some(h => this.selectedShipmentId.includes(h))
  }

  get headerCheckboxIndeterminate(): boolean {
    return this.isSomePageSelected && !this.isAllPageSelected
  }

  private tableCellMapper(value: unknown, colWidth: string, paddingRight?: string): DataObject {
    const customStyle = {
      maxWidth: colWidth,
      minWidth: colWidth,
      paddingRight: paddingRight || '8px',
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const o = value as DataObject
      return {
        ...o,
        customStyle: { ...customStyle, ...o.customStyle },
      } as DataObject
    }
    return {
      value: value as DataObject['value'],
      customStyle,
    }
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    withSort?: boolean,
    sortName?: string,
    sortWidth?: string
  ): HeaderObject {
    return {
      title: <string>title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
      withSort,
      sortName: sortName,
      sortStyle: {
        marginLeft: sortWidth,
      },
    }
  }

  private formattedRescheduleType(status?: string): string {
    if(status === EnumReschedulePickupType.CHANGE_TIME) {
      return 'Pergantian Waktu'
    }

    if(status === EnumReschedulePickupType.CHANGE_TIME_AND_COURIER) {
      return 'Pergantian Waktu dan Kurir'
    }

    if(status === EnumReschedulePickupType.MANUAL_ASSIGN) {
      return 'Manual Assign'
    }

    return '-'
  }

  private decideStatus(status: string): string {
    switch(status) {
      case EnumReschedulePickupStatus.APPROVE:
        return 'Diterima'
      case EnumReschedulePickupStatus.WAITING_FOR_APPROVAL:
        return 'Menunggu'
      case EnumReschedulePickupStatus.REJECT:
        return 'Ditolak'
    }
    return '-'
  }

  get addressFilterTitle(): string {
    const selectedFilter = [this.parameters.subDistrict?.value, this.parameters.village?.value].filter((item) => item)
    return selectedFilter.length ? `${selectedFilter.length} Filter Terpilih` : "Filter"
  }

  private getSubDistrict(name?: string):void {
    const param = {
      name: name || ""
    }
    controller.getSubDistrict(name ? param : undefined)
  }

  public filterSubDistrict = Utils.debounce((name: string) => {
    this.getSubDistrict(name)
  }, 400)

  private getVillages():void {
    const param = {
      name: '',
      sub_district: <string>this.parameters.subDistrict?.value
    }
    controller.getVillage(param)
  }

  public onPaginationPerPageChange(val: number): void {
    this.parameters.perPage = Number(val)
    this.fetchReschedulePickup(true)
  }

  get schTotalItems(): number {
    return this.controller.pagination.totalItem ?? 0
  }

  get isMyWhitelist() {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  @Watch('isMyWhitelist')
  isMyWhitelistChanged() {
    this.fetchReschedulePickup(true);
  }

  public async fetchReschedulePickup(reset = false): Promise<void> {
    if(reset) this.parameters.page = 1

    this.revealed = new Set();
    const param: Record<string, string | number | Date> = {
      page: this.parameters.page,
      per_page: this.parameters.perPage,
      sub_district: this.parameters.subDistrict?.value || '',
      village: this.parameters.village?.value || '',
      reschedule_type: encodeURI(String(this.parameters.schedule?.value) || ''),
      keyword: this.parameters.search,
      order_by: this.parameters.sort.name,
      sort: this.parameters.sort.direction,
      origin_country: this.isMyWhitelist ? 'Malaysia' : ''
    }

    if(this.parameters.date.start && this.parameters.date.end) {
      param.start_date = dayjs(this.parameters.date.start || "" as string).format('YYYY-MM-DD'),
      param.end_date = dayjs(this.parameters.date.end || "" as string).format('YYYY-MM-DD')
    }

    this.controller.getAllV2(param)
    this.isButtonDisable = true
  }

  public selectSubDistrict(): void {
    this.parameters.village = this.villageOptions[-1]
    this.refetchFilter()
  }

  public refetchFilter = Utils.debounce(() => {
    this.fetchReschedulePickup(true)
  }, 400)

  get latestSync(): string {
    if (!this.pickupController.latestSync) {
      return ''
    }

    return `${dayjs(this.pickupController.latestSync).format(
      'DD-MM-YY, HH:mm'
    )} WIB`
  }

  onResetFilterBox(): void {
    this.parameters.village = this.villageOptions[-1]
    this.parameters.subDistrict = this.subDistrictOptions[-1]
    this.popupFilterVisible = false
    this.appliedFilter = 0

    this.fetchReschedulePickup(true)
  }

  formatDuration(duration: string | undefined): string {
    return duration ? duration.replace("Hari", "d").replace("Jam", "h").replace("Menit", "m") : "-"
  }

  private manageDataReschedulePickups(reschedules: ReschedulePickup[]): void {
    this.dataReschedule =  reschedules.map((item, idx) => {
      const clientLine =
        item.clientId != null && String(item.clientId) !== ''
          ? `(${item.clientId} - ${item.clientName || '-'})`
          : ''
      const courier = item.courier
      return [
        this.tableCellMapper({ shipmentId: item?.shipmentId }, '32px'),
        this.tableCellMapper(`${idx + 1 + this.parameters.perPage * (this.parameters.page -1)}.`, '60px'),
        this.tableCellMapper({
            shipmentId: item.shipmentId,
            senderName: item.customerName,
            senderPhone: item.customerPhoneNumber,
            clientLine,
            isPriority: item.isPriority,
          },
          '200px'
        ),
        this.tableCellMapper(
          {
            totalShipments: item.totalShipment,
            totalQuantity: item.totalQuantity,
            shipmentId: item.shipmentId
          },
          '160px'
        ),
        this.tableCellMapper(this.formattedRescheduleType(item.rescheduleType), '160px'),
        this.tableCellMapper(
          {
            shipmentId: item.shipmentId,
            courierId: courier?.courierId ?? '',
            courierName: courier?.fullname ?? '',
            courierPhone: courier?.phoneNumber ?? '',
            rescheduleType: item.rescheduleType ?? '',
            courierType: courier?.courierType ?? ''
          },
          '170px'
        ),
        this.tableCellMapper(
          item.rescheduledAt ? Utils.formatTimeZone(
            Utils.formatDateWithIDLocale(
              item.rescheduledAt,
              'DD MMM YYYY HH:mm Z'
            )
          ) : '-',
          '180px'
        ),
        this.tableCellMapper({shipmentId: item.shipmentId, address: item?.customerAddress, lon: item.longitude, lat: item.latitude }, '200px'),
        this.tableCellMapper(
          item.createdAt ? Utils.formatTimeZone(
            Utils.formatDateWithIDLocale(
              item.createdAt,
              'DD MMM YYYY HH:mm Z'
            )
          ) : '-',
          '175px'
        ),
        this.tableCellMapper(this.formatDuration(item?.duration), '180px'),
        this.tableCellMapper(this.decideStatus(<string>item?.statusApproval), '175px'),
        this.tableCellMapper(item?.shipmentId, '80px'),
      ]
    })
  }

  onDetailClick(shipmentId: string): void {
    this.$router.push({ name: 'ReschedulePickupDetail_V2', params: { rescheduleId: shipmentId } })
  }

  showModalConfirmation(action: "APPROVE" | "REJECT"): void {
    if (action == "APPROVE") {
      this.modalConfirmation.title = "Terima Jadwal Ulang Pick Up?"
      this.modalConfirmation.actionTitle = "Terima"
      this.modalConfirmation.description = "Pastikan data yang Anda terima sudah sesuai"
      this.showModal.confirm = true
    } else {
      this.modalConfirmation.title = "Tolak Jadwal Ulang Pick Up?"
      this.modalConfirmation.actionTitle = "Tolak"
      this.modalConfirmation.description = "Pastikan data yang Anda tolak sudah sesuai"
      this.showModal.input = true
    }
  }

  onActionModal(): void {
    this.showModal.confirm = false
    if (this.modalConfirmation.actionTitle === "Terima") {
      controller.requestApprove(this.selectedShipmentId)
      this.successModal.title = "Terima Jadwal Ulang Berhasil"
      this.successModal.description = "Jadwal ulang berhasil dibuat"
    } else {
      controller.requestReject({
        ids: this.selectedShipmentId,
        reason: this.modalInputValue
      })
      this.successModal.title = "Tolak Jadwal Ulang Berhasil"
      this.successModal.description = "Jadwal ulang gagal dibuat"
      this.modalInputValue = ""
    }

    this.selectedShipmentId = []
  }

  onChangeModalInput(value: string): void {
    this.modalInputValue = value
  }

  onContinueReject(): void {
    this.showModal.input = false
    this.showModal.confirm = true
  }

  onActionSuccess(): void {
    this.showModal.success = false
    this.fetchReschedulePickup(true)
    controller.getCounter();
  }

  onCloseInput(): void {
    this.showModal.input = false
    this.modalInputValue = ""
  }

  decideClass(status: string):string {
    if(status === 'Menunggu') {
      return 'warning'
    }
    if(status === 'Ditolak') {
      return 'error'
    }
    return 'success'
  }

  public onDataTableSort(val: SortValueObject): void {
    this.parameters.sort = {
      name: val.name ?? '',
      direction: val.direction ?? 'DESC',
    }
    this.fetchReschedulePickup(true)
  }

  public onHeaderSort(sortName: string): void {
    const cur = this.parameters.sort
    if (!cur.direction && !cur.name) {
      this.onDataTableSort({ direction: 'ASC', name: sortName })
    } else if (sortName === cur.name) {
      if (cur.direction === 'ASC') {
        this.onDataTableSort({ direction: 'DESC', name: sortName })
      } else if (cur.direction === 'DESC') {
        this.onDataTableSort({ direction: '', name: '' })
      }
    } else {
      this.onDataTableSort({ direction: 'ASC', name: sortName })
    }
  }

  public isHeaderSortDirection(direction: 'ASC' | 'DESC', sortName: string): boolean {
    return (
      this.parameters.sort.name === sortName &&
      this.parameters.sort.direction === direction
    )
  }

  // ponytail: eye-toggle reveal on list; list API sends empty values, so reveal fetches from adminContactShow
  revealed: Set<string> = new Set()

  isRevealed(shipmentId: string, field: string): boolean {
    return this.revealed.has(`${shipmentId}-${field}`)
  }

  findItem(shipmentId: string): ReschedulePickup | undefined {
    return this.controller.dataReschedulePickups.find(p => p.shipmentId === shipmentId)
  }

  customerAddress(shipmentId: string): string {
    return this.findItem(shipmentId)?.customerAddress || '-'
  }

  customerPhone(shipmentId: string): string {
    return this.findItem(shipmentId)?.customerPhoneNumber || ''
  }

  courierPhone(shipmentId: string): string {
    return this.findItem(shipmentId)?.courier?.phoneNumber || ''
  }

  async showField(shipmentId: string, field: string, apiField: string): Promise<void> {
    if (!shipmentId) return
    const item = this.findItem(shipmentId)
    if (!item) return
    try {
      const resp = await this.pickupController.adminContactShow({
        resource: field === "courierPhone" ? "courier" : "shipment",
        resourceId: field === "courierPhone" ? String(item.courier?.courierId) : shipmentId,
        field: apiField,
        source: 'pickup_reschedulev2'
      })
      if (field === 'phone') {
        item.customerPhoneNumber = resp.value || '-'
      } else if (field === 'courierPhone') {
        if (item.courier) item.courier.phoneNumber = resp.value || '-'
      } else if (field === 'address') {
        item.customerAddress = resp.value || '-'
      }
      this.revealed.add(`${shipmentId}-${field}`)
      this.revealed = new Set(this.revealed)
    } finally {
      // no loading
    }
  }

  hideField(shipmentId: string, field: string): void {
    const item = this.findItem(shipmentId)
    if (item) {
      if (field === 'phone') {
        item.customerPhoneNumber = ''
      } else if (field === 'courierPhone') {
        if (item.courier) item.courier.phoneNumber = ''
      } else if (field === 'address') {
        item.customerAddress = ''
      }
    }
    this.revealed.delete(`${shipmentId}-${field}`)
    this.revealed = new Set(this.revealed)
  }

  @Watch('controller.dataReschedulePickups')
  onWatchReschedulePickups(value: ReschedulePickup[]): void {
    this.manageDataReschedulePickups(value)
    this.pickupController.setLatestSync(new Date().toISOString())
  }

  @Watch('controller.dataSubDistricts')
  onWatchSubDistricts(value: SubDistrict[]): void {
    this.subDistrictOptions = value.map((item: SubDistrict) => {
      return {
        label: <string>item?.subDistrict,
        value: <string>item?.subDistrict
      }
    })
  }

  @Watch('parameters.subDistrict')
  onWatchSubDistrict(value: Dropdown): void {
    if(value) {
      this.getVillages()
    }
  }

  @Watch('controller.dataVillages')
  onWatchDataVillages(value: Village[]): void {
    this.villageOptions = value.map((item: Village) => {
      return {
        label: <string>item?.village,
        value: <string>item?.village
      }
    })
  }

  @Watch('headerCheckboxIndeterminate')
  private syncSelectAllCheckboxIndeterminate(): void {
    this.$nextTick(() => {
      const r = this.$refs.pickupCrrscdSelectAllCheckbox as
        | HTMLInputElement
        | HTMLInputElement[]
        | undefined
      const el = Array.isArray(r) ? r[0] : r
      if (el) {
        el.indeterminate = this.headerCheckboxIndeterminate
      }
    })
  }

  @Watch('selectedShipmentId', { deep: true })
  onDataOnChecked(value: string[]): void {
    const datas = controller.dataReschedulePickups.filter((item) => value.includes(item.shipmentId || ""))
    if(
      datas.some(i => i.statusApproval !== EnumReschedulePickupStatus.WAITING_FOR_APPROVAL) ||
      datas.some(i => i.courier?.fullname === '') ||
      datas.length === 0
    ) {
      this.isButtonDisable = true
    } else {
      this.isButtonDisable = false
    }
  }

  @Watch('controller.isApproved')
  onWatchErrorRequest(value: boolean): void {
    if (value) {
      this.showModal.success = true
      controller.setIsApproved(false)
    }
  }
}
export default RescheduleV2;
